import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { PDxSystemSettingType, SettingInformation } from '../models/setting-information.model';
import { FocusMeDirective } from 'src/app/core/focus-me/focus-me.directive';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';

@Component({
  selector: 'app-settings-properties',
  templateUrl: './settings-properties.component.html',
  styles: []
})
export class SettingsPropertiesComponent implements OnInit {

  @ViewChild(NgForm) settingsForm!: NgForm;
  pdxSystemSettingType = PDxSystemSettingType;
  submitAttempt: boolean = false;
  setting: SettingInformation;
  public Editor = ClassicEditor;
  public config = {
    toolbar: {
      items: ['heading', '|',
        'bold', 'italic', '|',
        'link', '|',
        'outdent', 'indent', '|',
        'bulletedList', 'numberedList', '|',
        'insertTable', '|',
        'imageUpload', 'blockQuote', '|',
        'undo', 'redo'
      ]
    }
  };

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  save(): void {
    this.submitAttempt = true;
    if (this.settingsForm.invalid) {
      return;
    }

    this.ajax.MakeCall<void>('/Setting/Save', this.setting).then(() => {
      this.modal.close();
    }, () => { });
  }

  @ViewChild('editor', { static: false }) editorComponent: CKEditorComponent;

  onEditorReady(event: any): void {
    /*    console.log(event);
        console.log(this.editorComponent);
        const toolbarItems = Array.from(event.ui.componentFactory.names());
        console.log('Available toolbar items: ' + toolbarItems.join(', '));*/
  }
}
